import { useEffect, useRef } from "react";

const usePrevious = <V>(value: V) => {
  const ref = useRef<V>();

  useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref.current;
};

export default usePrevious;
